import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../base-api.service';
import { Language } from '../../model/language';

@Injectable({
  providedIn: 'root'
})
export class LanguageService extends BaseApiService<Language, string> {
  protected endpoint = '/language';

  constructor(protected override http: HttpClient) {
    super(http);
  }
}
